<!--
@Purpose: The browser returns a 404 HTML page when the server doesn’t find anything on the requested location.
-->
 <template>
  <div class="row">
    <div class="col-12 text-center">
      <div class="content">
        <img alt="" src="/images/error-img.png" class="img-fluid" alt="404 Page">
        <p>{{ $t('message.404-errortext') }}</p>
        <router-link to="/" class="error-btn">{{ $t('message.404-backbutton') }}</router-link>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  name: "NotFound"
};
</script>